class semiModal {
  constructor() {
    this.openButton = document.querySelector(".js-open-modal");
    this.closeButton = document.querySelector(".js-close-modal");
    this.dialog = document.querySelector("dialog");

    if (!this.openButton) return;

    this.openButton.addEventListener("click", () => {
      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      }
    });

    this.closeButton.addEventListener("click", () => {
      this.dialog.close();
    });
  }
}

export { semiModal };
